import { normalizeWorkApiRequestUrl } from "../../../utils/workApiUrl.mjs";

/** Resolve existing Work PDF payloads without waiting for the viewer engine. */
export async function resolvePdfSource(item, work, workUrl) {
    if (item.minio && (!item.articolo || !item.disegno)) return { url: item.minio, revokeOnClose: item.revokeOnClose === true };
    if (item.oseon) {
        const response = await work.get(normalizeWorkApiRequestUrl(item.oseon), {}, false, null, {
            responseType: "blob", timeout: 120000,
            ignoreGlobalErrorStatuses: [404, 409, 422, 500, 502, 503],
        });
        const contentType = response?.headers?.["content-type"] || response?.data?.type || "";
        if (!contentType.toLowerCase().includes("application/pdf")) {
            const error = new Error("Il server non ha restituito un PDF valido");
            error.response = response;
            throw error;
        }
        return { url: URL.createObjectURL(response.data), revokeOnClose: true };
    }
    if (item.articolo !== undefined) {
        const response = await work.post("/arts/disegno/", { art: item.articolo, disegno: item.disegno });
        if (response?.data?.minio) return { url: response.data.minio, revokeOnClose: false, revision: response.data.pdf_revision };
        if (item.pdf === undefined) {
            const file = await work.post("/filekey/", { cmd: "disegno", articolo: item.articolo, disegno: item.disegno });
            if (!file?.data?.key) throw new Error("Il disegno non è disponibile. Riprova o verifica i file dell’articolo.");
            return { url: `${workUrl}/commesse/getfile/${file.data.key}`, revokeOnClose: false };
        }
    }
    if (item.pdf !== undefined) return { url: `${workUrl}/commesse/getfile/${item.pdf}`, revokeOnClose: false };
    throw new Error("Nessun PDF disponibile per questo documento.");
}
